import { UserPlus02 } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/containers/Modal";
import Button from "@/components/forms/Button";
import FeatureIcon from "@/components/helpers/FeatureIcon";

type AddUsersConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  selectedCount: number;
  userName?: string;
};

export default function AddUsersConfirmModal({
  open,
  onClose,
  onConfirm,
  isLoading,
  selectedCount,
  userName,
}: AddUsersConfirmModalProps) {
  const { t } = useTranslation("messenger.user");

  const title = t("Add User");
  const description =
    selectedCount === 1
      ? t("Are you sure you want to add {{userName}} to the group?", {
          userName: userName ?? "",
        })
      : t("Are you sure you want to add {{count}} users to the group?", {
          count: selectedCount,
        });

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      footer={
        <div className="grid grid-cols-1 gap-3 border-t p-6">
          <Button
            color="primary"
            className="w-full"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {t("Add", { ns: "core.shared" })}
          </Button>
          <Button color="secondary-gray" className="w-full" onClick={onClose}>
            {t("Cancel", { ns: "core.shared" })}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <FeatureIcon variant="modern" color="primary" className="self-start">
          <UserPlus02 className="text-primary-600 size-5" />
        </FeatureIcon>
        <div className="flex flex-col gap-2">
          <span className="text-lg font-semibold text-gray-900">{title}</span>
          <span className="text-sm text-gray-600">{description}</span>
        </div>
      </div>
    </Modal>
  );
}
